import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../../firebase/firebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import Portada from "../../components/Portada/Portada";
import Footer from "../../components/Footer/Footer.js";
import Spinner from "react-bootstrap/Spinner";
import "./ProductoDetalle.css";

const ProductoDetalle = () => {
    const { id } = useParams();
    const [producto, setProducto] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const fetchProducto = async () => {
            setLoading(true);
            const productoRef = doc(db, "productos", id);
            const productoSnap = await getDoc(productoRef);
            if (productoSnap.exists()) {
                setProducto({ id: productoSnap.id, ...productoSnap.data() });
            }
            setLoading(false);
        };
        fetchProducto();
    }, [id]);

    if (loading) {
        return (
            <div className="loading-container d-flex justify-content-center align-items-center">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Cargando...</span>
                </Spinner>
            </div>
        );
    }

    const linkWhatsApp = `https://wa.me/541154858252?text=Hola, me interesa el producto ${producto.name}. ¿Podrían darme más información?`;

    return (
        <article className="producto-detalle-container">
            <Portada titulo="Detalle" />

            <header>
                <title>{`Producto: ${producto.name} | Detalle`}</title>
                <meta name="description" content={`Descubre más sobre el producto ${producto.name}. ${producto.description.slice(0, 150)}...`} />
                <meta property="og:title" content={`Producto: ${producto.name}`} />
                <meta property="og:description" content={producto.description} />
            </header>

            <h2 className="breadcrumb categoria-margen m-4">
                PRODUCTOS | {producto.category?.toUpperCase()}
            </h2>

            <section className="detalle-content">
                <article className="detalle-card col-10 col-md-7 col-lg-3">
                    <img
                        src={`/images/${producto.pictureUrl}`}
                        alt={`Imagen del producto ${producto.name}`}
                        className="detalle-imagen"
                    />
                </article>

                <section className="detalle-info col-10 col-md-7 col-lg-4 mt-2">
                    <h3 className="categoria">{producto.category}</h3>
                    <h1 className="titulo">{producto.name}</h1>

                    <p className="mb-0 tlt-campo">CARACTERISTICAS</p>
                    {Array.isArray(producto.description) ? (
                        <ul className="descripcion-list" style={{ listStyleType: "none", paddingLeft: 0 }}>
                            {producto.description.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    ) : (
                        <p className="descripcion">{producto.description}</p>
                    )}

                    <p className="mb-0 tlt-campo">MEDIDAS DISPONIBLES</p>
                    {Array.isArray(producto.medidas) ? (
                        <ul className="descripcion-list" style={{ listStyleType: "none", paddingLeft: 0 }}>
                            {producto.medidas.map((medida, index) => (
                                <li key={index}><strong>-</strong> {medida}</li>
                            ))}
                        </ul>
                    ) : (
                        <p className="descripcion">{producto.medidas}</p>
                    )}

                    <ul className="tamaños" style={{ listStyleType: "none", paddingLeft: 0 }}>
                        {producto.sizes?.map((size, index) => (
                            <li key={index}><strong>-</strong> {size}</li>
                        ))}
                    </ul>

                    <button className="btn-consultar col-12 col-md-6 col-lg-6">
                        <a
                            href={linkWhatsApp}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="a-consultar"
                            aria-label="Consultar por WhatsApp sobre este producto"
                        >
                            CONSULTAR
                        </a>
                    </button>
                </section>
            </section>

            <Footer />
        </article>
    );
};

export default ProductoDetalle;
